import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
  const { t } = useTranslation('latvia');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1'),
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2'),
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3'),
    },
    {
      question: t('faq.q4'),
      answer: t('faq.a4'),
    },
    {
      question: t('faq.q5'),
      answer: t('faq.a5'),
    },
    {
      question: t('faq.q6'),
      answer: t('faq.a6'),
    },
    {
      question: t('faq.q7'),
      answer: t('faq.a7'),
    },
    {
      question: t('faq.q8'),
      answer: t('faq.a8'),
    },
    {
      question: t('faq.q9'),
      answer: t('faq.a9'),
    },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-6 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-gray-900 mb-2 md:mb-4 font-serif">
            {t('faq.title')}
          </h2>
          <p className="text-xs md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('faq.description')}
          </p>
        </div>

        <div className="space-y-2 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-lg md:rounded-xl overflow-hidden transition-all duration-300 hover:shadow-md"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full p-3 md:p-6 text-left cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <div className="flex items-start justify-between gap-2 md:gap-3">
                  <div className="flex items-start flex-1">
                    <div className="w-7 h-7 md:w-10 md:h-10 flex items-center justify-center bg-gold-100 rounded-md md:rounded-lg mr-2.5 md:mr-4 flex-shrink-0">
                      <i className="ri-question-line text-sm md:text-xl text-gold-600"></i>
                    </div>
                    <h3 className="text-xs md:text-lg font-bold text-gray-900 pt-0.5 md:pt-1.5 leading-snug md:leading-normal">
                      {faq.question}
                    </h3>
                  </div>
                  <div className="flex-shrink-0 mt-0.5">
                    <i
                      className={`ri-arrow-down-s-line text-lg md:text-2xl text-gold-600 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </div>
                </div>
              </button>
              <div
                id={`faq-answer-${index}`}
                className="overflow-hidden transition-all duration-300"
                style={{
                  maxHeight: openIndex === index ? '600px' : '0px',
                }}
                aria-hidden={openIndex !== index}
              >
                <div className="px-3 md:px-6 pb-3 md:pb-6 pl-[2.5rem] md:pl-[4.5rem]">
                  <p className="text-gray-600 text-[11px] md:text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;